module.exports = __webpack_public_path__ + "img/shoot_00007.1840f853.png";